<template>
  <!-- Overlay effect when opening sidebar on small screens -->
  <div
    class="w3-overlay w3-hide-large"
    :style="{display: visible ? 'block' : 'none' }"
    @click="closeNav"
  ></div>
</template>

<script>
  export default {
    name: 'overlay',
    methods: {
      closeNav() {
        this.$store.commit('setNavbarVisibility', false);
      },
    },
    computed: {
      visible() {
        return this.$store.state.navbarVisible;
      },
    },
  };

</script>

<style scoped>
  div {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// Overlay.vue?b9d9ebc0